import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useAuth } from '../aws/AuthContext';
import { message } from 'antd';

export const useZonas = () => {
  const { getJwtToken } = useAuth();
  const API_URL = process.env.REACT_APP_API_URL;
  const queryClient = useQueryClient();

  // 1. Obtener todas las zonas
  const getZonas = useQuery({
    queryKey: ['zonas'],
    queryFn: async () => {
      const token = await getJwtToken();
      const res = await axios.get(`${API_URL}/v1-zonas`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return res.data;
    }
  });

  // 2. Crear nueva zona
  const saveZona = useMutation({
    mutationFn: async (payload) => {
      const token = await getJwtToken();
      if (payload.id) {
        return await axios.put(`${API_URL}/v1-zonas/${payload.id}`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        return await axios.post(`${API_URL}/v1-zonas`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['zonas'] });
      message.success('Zona guardada correctamente');
    },
    onError: (err) => {
      message.error(err.response?.data?.error || 'Error al guardar la zona');
    }
  });

  // 3. Eliminar zona
  const deleteZona = useMutation({
    mutationFn: async (id) => {
      const token = await getJwtToken();
      return await axios.delete(`${API_URL}/v1-zonas/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['zonas'] });
      message.success('Zona eliminada exitosamente');
    },
    onError: (err) => {
      message.error(err.response?.data?.error || 'Error al eliminar la zona');
    }
  });

  return {
    zonas: getZonas.data || [],
    isLoading: getZonas.isLoading,
    refetchZonas: getZonas.refetch,
    saveZona,
    deleteZona
  };
};